import type { JurisdictionType } from '@/types/sled-contract/Api'
import type { SledContractSearchFilter } from '@/types/sled-contract/Filter'

export const DEFAULT_SLED_CONTRACT_FILTER: SledContractSearchFilter = {
  active_after: null,
  active_before: null,
  published_after: null,
  published_before: null,
  is_active: null,
  jurisdiction_ids: [],
  nigp_codes: [],
  unspsc_codes: [],
}

export const JURISDICTION_INDEX_MAP: Record<JurisdictionType, number> = {
  City: 0,
  County: 1,
  State: 2,
}
